// extracted by mini-css-extract-plugin
export default {"absolute":"styles_absolute__nY7NK","show":"styles_show__lIrL0"};